export const actionNameSymbol = '🙈actionName🙈';
export const actionSymbol = '🙈action🙈';
export const actionStateSymbol = '🙈actionState🙈';

export const computedSymbol = '🙈computedSymbol🙈';
export const computedConfigSymbol = '🙈computedConfigSymbol🙈';

export const listenSymbol = '🙈listen🙈';

export const metaSymbol = '🙈meta🙈';

export const reducerSymbol = '🙈reducer🙈';

export const selectDependenciesSymbol = '🙈selectDependencies🙈';
export const selectImpSymbol = '🙈selectImp🙈';
export const selectStateSymbol = '🙈selectState🙈';
export const selectSymbol = '🙈select🙈';

export const selectorSymbol = '🙈selector🙈';
export const selectorConfigSymbol = '🙈selectorConfig🙈';
export const selectorStateSymbol = '🙈selectorState🙈';

export const thunkSymbol = '🙈thunk🙈';
export const thunkStateSymbol = '🙈thunkState🙈';
